import React, { useState } from "react";
import { Container, Box } from "@mui/material";
import ReviewData from "../../Components/ReviewData";
import { useSelector } from "react-redux";
import CrossingTradeRebalancer from "../../Popup/CrossingTradeRebalancer";
import { selectSleeveDataStageOne } from "../../../../Redux/Reducers/selectors";
import {
  rebalancerStepContainerWithBottomMarginSx,
  rebalancerFillColumnSx,
} from "../../styles/rebalancerStyles";

const FundStep2 = ({ setCurrentStep, sleeve, driftValue,rebalanceType,rebalancedFunds,rebalancedStrategies,deltaRebalancer }) => {
  
  const sleeveDataStageOne = useSelector(selectSleeveDataStageOne);
  const [existingNewArray, setExistingNewArray] = useState({});
  const [openCrossPopup, setOpenCrossPopup] = useState(false);
  const [onceClicked, setOnceClicked] = useState(false);
  return (
    <Container disableGutters maxWidth="100%" sx={rebalancerStepContainerWithBottomMarginSx}>
      <Box sx={rebalancerFillColumnSx}>
        <ReviewData
          sleeve={sleeve}
          setExistingNewArray={setExistingNewArray}
          existingNewArray={existingNewArray}
          sleeveDataStageOne={sleeveDataStageOne}
          setOpenCrossPopup={setOpenCrossPopup}
          setOnceClicked={setOnceClicked}
          onceClicked={onceClicked}
          showNext={true}
          driftValue={driftValue}
          rebalanceType={rebalanceType}
          rebalancedFunds={rebalancedFunds}
          rebalancedStrategies={rebalancedStrategies}
          deltaRebalancer={deltaRebalancer}
        />
      </Box>
      <CrossingTradeRebalancer
        title="Orders"
        openCrossPopup={openCrossPopup}
        setOpenCrossPopup={setOpenCrossPopup}
        setCurrentStep={setCurrentStep}
        showNext={true}
        rebalanceType={rebalanceType}
        rebalancedFunds={rebalancedFunds}
      />
    </Container>
  );
};

export default FundStep2;
